import styled from '@emotion/styled'
import { Form } from 'antd'

const StyledFormItem = styled(Form.Item)`
  form.ant-form & .ant-form-item-label label {
    font-weight: 600;
    font-size: 12px;
  }

  form.ant-form-large & .ant-form-item-label > label {
    height: auto;
    min-height: 20px;
  }

  form.ant-form-large & .ant-form-item-control > .ant-form-item-control-input {
    height: auto;
    min-height: 20px;
  }
`

export const FormItem = Object.assign(StyledFormItem, Form.Item)
